import { makeStyles } from '@map/theme';
import { Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles(({ palette, spacing }, { dense }: Props) => ({
  socialDivider: {
    margin: spacing(dense ? 3 : 6, 0),
    fontWeight: 700,
    color: palette.neutrals[800],
    display: 'grid',
    gridTemplateColumns: 'minmax(20px, 1fr) auto minmax(20px, 1fr)',
    alignItems: 'center',
    gridGap: 5,
    '&::before, &::after': {
      content: '""',
      borderTop: `1px solid ${palette.divider}`,
    },
  },
}));

type Props = { dense?: boolean };

const FormDivider: FC<Props> = (props) => {
  const { classes } = useStyles(props);

  return (
    <Typography variant="body3" className={classes.socialDivider} component="div">
      <FormattedMessage id="registration.or" />
    </Typography>
  );
};

export default FormDivider;
